<template>
  <div class="items-section">
    <div class="section-header">
      <h3 class="section-title">{{ $t("globals.services_services") }}</h3>
      <div class="header-actions">
        <button @click="openFieldtrackerModal" class="primary-action-btn">
          {{$t('globals.request_fieldtracker_service')}}
        </button>
        <b-dropdown
          size="sm"
          class="modern-dropdown"
          :text="$t('globals.request_service')"
        >
                  <b-dropdown-item
                    v-if="getUserBrandPermissions.order_service_create_replace"
                    @click="openReplaceModal"
                  >
                    {{ $t("globals.replacement") }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="getUserBrandPermissions.order_service_create_replace"
                    @click="openServiceCallModal"
                  >
                    {{ $t("globals.service_call") }}
                  </b-dropdown-item>
                  <b-dropdown-item
                      v-if="getUserBrandPermissions.order_service_create_install"
                      @click="openInstallModal">
                    {{ $t("globals.install") }}
                  </b-dropdown-item>
                  <b-dropdown-item
                      v-if="getUserBrandPermissions.order_service_create_install"
                      @click="separateInstallModal.show = true">
                    {{ $t("globals.separate_install") }}
                  </b-dropdown-item>
                  <b-dropdown-item
                      v-if="getUserBrandPermissions.order_service_create_replace"
                      @click="separateReplaceModal.show = true">
                    {{ $t("globals.separate_replace") }}
                  </b-dropdown-item>
                  <b-dropdown-item
                      v-if="getUserBrandPermissions.order_service_create_replace"
                      @click="separateServiceCallModal.show = true">
                    {{ $t("globals.separate_service_call") }}
                  </b-dropdown-item>
                  <!--
                  <b-dropdown-item
                      v-if="getUserBrandPermissions.order_service_create_remove"
                      @click="openReplaceModal">
                    {{ $t("globals.remove") }}
                  </b-dropdown-item>
                  -->
        </b-dropdown>
      </div>
    </div>

    <div class="filters-section">
      <div class="search-container">
        <input
          v-model="filter"
          :placeholder="$t('globals.type_to_search')"
          class="search-input"
        />
      </div>
      <button
        v-if="filter"
        @click="filter = ''"
        class="search-btn"
      >
        {{ $t("globals.clear") }}
      </button>
    </div>

    <div class="table-wrapper">
      <table class="modern-table">
        <thead>
          <tr>
            <th v-for="field in fields" :key="field.key" :class="{ sortable: field.sortable }" @click="field.sortable && toggleSort(field.key)">
              {{ field.label }}
              <span v-if="sortBy === field.key" class="sort-icon">{{ sortDesc ? '▼' : '▲' }}</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in paginatedServices" :key="item.id" @click="goToService(item)">
            <td>{{ item.id }}</td>
            <td>{{ item.agent ? item.agent.full_name : '' }}</td>
            <td>{{ item.service_type }}</td>
            <td>{{ item.fieldtracker_task_name }}</td>
            <td>{{ item.assembly_type }}</td>
            <td>{{ item.status }}</td>
            <td>
              <v-icon v-if="item.warranty" name="regular/check-square"></v-icon>
              <v-icon v-else name="regular/square"></v-icon>
            </td>
            <td>
              <v-icon v-if="item.needs_to_be_billed" name="regular/check-square"></v-icon>
              <v-icon v-else name="regular/square"></v-icon>
            </td>
            <td :title="item.created_at">{{ item.created_at ? item.created_at.substring(0, 10) : '' }}</td>
          </tr>
          <tr v-if="paginatedServices.length === 0">
            <td :colspan="fields.length" class="empty-state-cell">
              {{ $t("globals.no_results") }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="pagination-section">
      <div class="controls-left">
        <span class="summary-label">{{ $t("globals.per_page") }}:</span>
        <select v-model="perPage" class="per-page-select">
          <option v-for="option in perPageOptions" :key="option.value" :value="option.value">
            {{ option.value }}
          </option>
        </select>
        <span class="pagination-info">
          {{ ((currentPage - 1) * perPage) + 1 }}-{{ Math.min(currentPage * perPage, filteredServices.length) }} of {{ filteredServices.length }}
        </span>
      </div>
      <div class="pagination-controls">
        <button class="page-btn" :disabled="currentPage === 1" @click="currentPage--">‹</button>
        <button
          v-for="page in visiblePages"
          :key="page"
          class="page-btn"
          :class="{ active: page === currentPage }"
          @click="currentPage = page"
        >
          {{ page }}
        </button>
        <button class="page-btn" :disabled="currentPage === totalPages" @click="currentPage++">›</button>
      </div>
    </div>



    <ulu-replace-modal
      :show="replaceModal.show"
      :close="closeModals"
      :devices="replaceModal.devices"
      :contactAllInfo="contactAllInfo"
    />
    <ulu-service-call-modal
      :show="serviceCallModal.show"
      :close="closeModals"
      :devices="serviceCallModal.devices"
      :contactAllInfo="contactAllInfo"
    />
    <ulu-install-modal
      :show="installModal.show"
      :close="closeModals"
      :devices="installModal.devices"
      :contactAllInfo="contactAllInfo"
      :availableInstallations="order.available_installations"
    />
    <ulu-separate-install-modal
      :show="separateInstallModal.show"
      :close="closeModals"
      :contactAllInfo="contactAllInfo"
      :availableInstallations="order.available_installations"
    />
    <ulu-separate-replace-modal
      :show="separateReplaceModal.show"
      :close="closeModals"
      :contactAllInfo="contactAllInfo"
      :availableInstallations="order.available_installations"
    />
    <ulu-separate-service-call-modal
      :show="separateServiceCallModal.show"
      :close="closeModals"
      :contactAllInfo="contactAllInfo"
      :availableInstallations="order.available_installations"
    />
    
    <fieldtracker-modal
      :show="fieldtrackerModal.show"
      :order="fieldtrackerModal.order"
      :close="closeModals"
      :devices="fieldtrackerModal.devices"
      :service="fieldtrackerModal.service"></fieldtracker-modal>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  components: {
    "ulu-replace-modal": () =>
      import("@/components/orders/order/order_services_tab/service_modals/ReplaceModal.vue"),
    "ulu-service-call-modal": () =>
      import("@/components/orders/order/order_services_tab/service_modals/ServiceCallModal.vue"),
    "ulu-install-modal": () =>
      import("@/components/orders/order/order_services_tab/service_modals/InstallModal.vue"),
    "ulu-separate-install-modal": () =>
      import("@/components/orders/order/order_services_tab/service_modals/SeparateInstallModal.vue"),
    "ulu-separate-replace-modal": () =>
      import("@/components/orders/order/order_services_tab/service_modals/SeparateReplaceModal.vue"),
    "ulu-separate-service-call-modal": () =>
      import("@/components/orders/order/order_services_tab/service_modals/SeparateServiceCallModal.vue"),
    "fieldtracker-modal": () =>
      import("@/components/orders/order/order_services_tab/service_modals/FieldtrackerModal.vue")
  },
  props: {
    refreshOrder: Function,
    contactAllInfo: String,
    order: Object
  },
  data() {
    return {
      sortBy: "id",
      sortDesc: true,
      fieldtrackerModal: {
        show: false,
        devices: [],
        order: this.order,
      },
      replaceModal: {
        show: false,
        devices: []
      },
      serviceCallModal: {
        show: false,
        devices: []
      },
      installModal: {
        show: false,
        devices: []
      },
      separateInstallModal: {
        show: false,
      },
      separateReplaceModal: {
        show: false,
      },
      separateServiceCallModal: {
        show: false,
      },
      filter: null,
      currentPage: 1,
      perPage: 10,
      perPageOptions: [
        { text: "10 " + this.$t("globals.per_page"), value: 10 },
        { text: "20 " + this.$t("globals.per_page"), value: 20 },
        { text: "30 " + this.$t("globals.per_page"), value: 30 }
      ],
      fields: [
        {
          key: "id",
          label: "ID"
        },
        {
          key: "agent.full_name",
          label: this.$t("globals.agent"),
        },
        {
          key: "service_type",
          label: this.$t("globals.type"),
        },
        {
          key: 'fieldtracker_task_name',
          label: this.$t("globals.fieldtracker_task_name"),
        },
        {
          key: "assembly_type",
          label: this.$t("globals.assembly"),
        },
        {
          key: "status",
          label: this.$t("globals.status"),
          sortable: true
        },
        {
          key: "warranty",
          label: this.$t("globals.warranty"),
          sortable: true
        },
        {
          key: "needs_to_be_billed",
          label: this.$t("globals.needs_to_be_billed"),
          sortable: true
        },
        {
          key: "created_at",
          label: this.$t("globals.created_at"),
          sortable: true
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["getUserBrandPermissions", "getBackendUrl"]),
    filteredServices() {
      if (!this.filter) return this.order.services || [];
      const filterLower = this.filter.toLowerCase();
      return (this.order.services || []).filter(item => {
        return Object.values(item).some(val =>
          String(val).toLowerCase().includes(filterLower)
        );
      });
    },
    sortedServices() {
      const services = [...this.filteredServices];
      if (!this.sortBy) return services;
      return services.sort((a, b) => {
        let aVal = a[this.sortBy];
        let bVal = b[this.sortBy];
        if (this.sortBy === 'agent.full_name') {
          aVal = a.agent ? a.agent.full_name : '';
          bVal = b.agent ? b.agent.full_name : '';
        }
        if (aVal < bVal) return this.sortDesc ? 1 : -1;
        if (aVal > bVal) return this.sortDesc ? -1 : 1;
        return 0;
      });
    },
    paginatedServices() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.sortedServices.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.filteredServices.length / this.perPage);
    },
    visiblePages() {
      const pages = [];
      const start = Math.max(1, this.currentPage - 2);
      const end = Math.min(this.totalPages, this.currentPage + 2);
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    }
  },
  methods: {
    ...mapMutations(["setShowLoadingModal"]),
    toggleSort(key) {
      if (this.sortBy === key) {
        this.sortDesc = !this.sortDesc;
      } else {
        this.sortBy = key;
        this.sortDesc = false;
      }
    },
    goToService(item) {
      this.$router.push({
        name: "service",
        params: { id: item.id }
      });
    },
    openFieldtrackerModal() {
      this.fieldtrackerModal.devices = this.order.devices.map(device => {
        return {
          id: device.id,
          imei: device.imei,
          status: device.status,
          product: device.product,
          selected: false
        };
      });
      this.fieldtrackerModal.show = true;
    },
    openReplaceModal() {
      this.replaceModal.devices = this.order.devices.map(device => {
        return {
          id: device.id,
          imei: device.imei,
          status: device.status,
          selected: false
        };
      });
      this.replaceModal.show = true;
    },
    openServiceCallModal() {
      this.serviceCallModal.devices = this.order.devices.map(device => {
        return {
          id: device.id,
          imei: device.imei,
          status: device.status,
          selected: false
        };
      });
      this.serviceCallModal.show = true;
    },
    openInstallModal() {
      this.installModal.devices = this.order.devices.map(device => {
        return {
          id: device.id,
          imei: device.imei,
          status: device.status,
          product: device.product,
          selected: false
        };
      });
      this.installModal.show = true;
    },
    closeModals() {
      this.replaceModal.show = false;
      this.serviceCallModal.show = false;
      this.installModal.show = false;
      this.separateInstallModal.show = false;
      this.separateReplaceModal.show = false;
      this.separateServiceCallModal.show = false;
      this.fieldtrackerModal.show = false;
      this.refreshOrder();
    }
  },
  mounted: function() {

  }
};
</script>

<style scoped>
.header-actions {
  display: flex;
  gap: 8px;
  align-items: center;
}

/* Modern Dropdown Styling */
.modern-dropdown ::v-deep .btn {
  background-color: #5469d4;
  border: none;
  padding: 0.625rem 1.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  border-radius: 6px;
  text-transform: uppercase;
  color: white;
  transition: background-color 0.2s;
}

.modern-dropdown ::v-deep .btn:hover,
.modern-dropdown ::v-deep .btn:focus,
.modern-dropdown ::v-deep .btn:active {
  background-color: #4353b8;
  border: none;
  box-shadow: none;
}

.modern-dropdown ::v-deep .dropdown-menu {
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 0.5rem 0;
}

.modern-dropdown ::v-deep .dropdown-item {
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  color: #495057;
  transition: background-color 0.2s;
}

.modern-dropdown ::v-deep .dropdown-item:hover {
  background-color: #f8f9fa;
  color: #5469d4;
}
</style>
